import React from 'react';

const EntrepreneurBottomline = () => {
  const benefits = [
    {
      title: "Business-Personal Balance Optimization",
      description: "Strategic financial planning creates clear boundaries between business and personal finances, ensuring business growth while building personal wealth independent of business valuation."
    },
    {
      title: "Risk Mitigation Architecture",
      description: "A comprehensive approach includes multiple layers of protection—from business structure to insurance strategies—safeguarding both business assets and personal wealth from various threats."
    },
    {
      title: "Tax Efficiency Maximization",
      description: "Sophisticated planning coordinates business and personal tax strategies to legally minimize the combined tax burden across both realms, potentially saving significant amounts annually."
    },
    {
      title: "Value Realization Pathways",
      description: "Well-structured exit and succession planning transforms business equity into personal wealth through clearly defined options including sale, family transition, or management buyout strategies."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Entrepreneur-Focused Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EntrepreneurBottomline;